import { Router, RouteComponentProps } from "@reach/router";
import React from 'react';
import SecondReviewDetails from './activity-details';
import SecondReviewEdit from './activity-edit';
import SecondReviewList from './activity-list';

const SecondReview: React.FC<RouteComponentProps> = () => (
  <Router>
    <SecondReviewList path="/" />
    <SecondReviewDetails path=":id" />
    <SecondReviewEdit path=":id/edit" />
    <SecondReviewEdit path="new" />
  </Router>
);
export default SecondReview;
